import { PlaceTypeEnum, PlaceTypeKeyEnum, PlaceTypeNameEnum, } from '../enums/PlaceTypeEnum';
// TODO remove after URL migration
const pluralByPlaceType = new Map()
    .set(PlaceTypeEnum.COUNTRY, 'countries')
    .set(PlaceTypeEnum.REGION, 'regions')
    .set(PlaceTypeEnum.SUBREGION, 'subregions')
    .set(PlaceTypeEnum.DISTRICT, 'districts')
    .set(PlaceTypeEnum.CITY, 'cities')
    .set(PlaceTypeEnum.SUBCITY, 'subcities')
    .set(PlaceTypeEnum.ARRMUN, 'arrmuns')
    .set(PlaceTypeEnum.BOROUGH, 'boroughs')
    .set(PlaceTypeEnum.NEIGHBORHOOD, 'neighborhoods')
    .set(PlaceTypeEnum.IRIS, 'irises')
    .set(PlaceTypeEnum.STREET, 'streets')
    .set(PlaceTypeEnum.BLOCK, 'blocks')
    .set(PlaceTypeEnum.PARCELLE, 'parcelles')
    .set(PlaceTypeEnum.BUILDING, 'buildings')
    .set(PlaceTypeEnum.ADDRESS, 'addresses');
const placeTypeByPlural = new Map();
pluralByPlaceType.forEach((plural, placeType) => {
    placeTypeByPlural.set(plural, placeType);
});
export function plural(placeType) {
    return pluralByPlaceType.get(placeType);
}
export function fromPlural(key) {
    return placeTypeByPlural.get(key);
}
const placeTypeNameByKey = new Map()
    .set(PlaceTypeKeyEnum.COUNTRY, PlaceTypeNameEnum.COUNTRY)
    .set(PlaceTypeKeyEnum.MACROREGION, PlaceTypeNameEnum.MACROREGION)
    .set(PlaceTypeKeyEnum.REGION, PlaceTypeNameEnum.REGION)
    .set(PlaceTypeKeyEnum.MICROREGION, PlaceTypeNameEnum.MICROREGION)
    .set(PlaceTypeKeyEnum.PROVINCE, PlaceTypeNameEnum.PROVINCE)
    .set(PlaceTypeKeyEnum.COUNTY, PlaceTypeNameEnum.COUNTY)
    .set(PlaceTypeKeyEnum.MUNICIPALITY, PlaceTypeNameEnum.MUNICIPALITY)
    .set(PlaceTypeKeyEnum.BOROUGH, PlaceTypeNameEnum.BOROUGH)
    .set(PlaceTypeKeyEnum.MACRO_NEIGHBORHOOD, PlaceTypeNameEnum.MACRO_NEIGHBORHOOD)
    .set(PlaceTypeKeyEnum.NEIGHBORHOOD, PlaceTypeNameEnum.NEIGHBORHOOD)
    .set(PlaceTypeKeyEnum.MICRO_NEIGHBORHOOD, PlaceTypeNameEnum.MICRO_NEIGHBORHOOD)
    .set(PlaceTypeKeyEnum.MACRO_STAT_UNIT, PlaceTypeNameEnum.MACRO_STAT_UNIT)
    .set(PlaceTypeKeyEnum.STATISTICAL_UNIT, PlaceTypeNameEnum.STATISTICAL_UNIT)
    .set(PlaceTypeKeyEnum.MICRO_STAT_UNIT, PlaceTypeNameEnum.MICRO_STAT_UNIT)
    .set(PlaceTypeKeyEnum.STREET, PlaceTypeNameEnum.STREET)
    .set(PlaceTypeKeyEnum.BLOCK, PlaceTypeNameEnum.BLOCK)
    .set(PlaceTypeKeyEnum.PARCEL, PlaceTypeNameEnum.PARCEL)
    .set(PlaceTypeKeyEnum.BUILDING, PlaceTypeNameEnum.BUILDING)
    .set(PlaceTypeKeyEnum.HOUSE_NUMBER, PlaceTypeNameEnum.HOUSE_NUMBER);
const PlaceTypeKeyEnumByName = new Map();
placeTypeNameByKey.forEach((key, name) => {
    PlaceTypeKeyEnumByName.set(key, name);
});
export function placeNameFromKey(placeType) {
    return placeTypeNameByKey.get(placeType);
}
export function placeKeyFromName(name) {
    return PlaceTypeKeyEnumByName.get(name);
}
export function getPlaceTypeFromPlaceId(place_id) {
    const temp_key = place_id.substring(0, 4).toUpperCase();
    return placeNameFromKey(temp_key);
}
